module.exports = __webpack_public_path__ + "img/theo-la-thich.65c02a3c.png";